import React, { useState, useEffect, useCallback, useRef } from "react";
import Header from "../../components/Header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SuccessNotification from "../../components/Notifications/SuccessNotification";
import ErrorNotification from "../../components/Notifications/ErrorNotification";
import LoginNotification from "../../components/Notifications/LoginNotification";
import {
  faEdit,
  faTrashAlt,
  faSearch,
  faMoneyCheckDollar,
  faCircleCheck,
  faCircleXmark,
  faEye,
  faEllipsisH,
  faCircleArrowLeft,
  faRotate,
} from "@fortawesome/free-solid-svg-icons";
import Table from "../../components/Table";
import Section from "../../components/Section";
import DeleteModal from "../../components/DeleteModal";
import SlideModal from "../../components/SlideModal";
import SyncProdPriceModal from "../../components/SyncProdPriceModal";
import apiClient from "../../axios";
import { Tooltip } from "react-tooltip";
import { useNavigate } from "react-router-dom";
import useEscapeKey from "../../hooks/useEscapeKey";

const ProductPriceList = ({ handleLogout }) => {
  const [data, setData] = useState([]);
  //const [search, setSearch] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const itemsPerPage = 10;
  const [isSuccessVisible, setIsSuccessVisible] = useState(false);
  const [isErrorVisible, setIsErrorVisible] = useState(false);
  const [isInfoVisible, setIsInfoVisible] = useState(false);
  const [selectedItemToggle, setSelectedItemToggle] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleteItem, setDeleteItem] = useState(false);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [isSyncOpen, setIsSyncOpen] = useState(false);
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  
  useEffect(() => {
    const handleClickOutside = (event) => {
      const isClickInsideDropdown = dropdownRef.current?.contains(event.target);
      const isDropdownItem = event.target.closest(".dm-class");

      if (!isClickInsideDropdown && !isDropdownItem) {
        setOpenDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEscapeKey(() => setIsModalOpen(false));

  const hasPermission = (permission) => {
    const permissions = JSON.parse(localStorage.getItem("permissions")) || [];
    return permissions.includes(permission);
  };

  const toggleModal = async (item) => {
    if (!isModalOpen) {
      try {
        const response = await apiClient.get(`/product_price/${item.id}`);
        const connection = {
          general: item,
          alternative: response.data,
        };
        setSelectedItemToggle(connection);
        setIsModalOpen(true);
      } catch (error) {
        setIsErrorVisible(true);
        if (error.response && error.response.status === 401) {
          setIsInfoVisible(true);
        }
      } finally {
        setIsSuccessVisible(true);
      }
    } else {
      setIsModalOpen(false);
    }
  };

  const fetchAllData = useCallback(async (page = 1) => {
    try {
      setLoading(true);
      const response = await apiClient.get(`/product_price?page=${page}`);
      if (Array.isArray(response.data.results)) {
        setData(response.data.results);
        setTotalItems(response.data.total);
      } else {
        setData([response.data.results]);
        setTotalItems(1);
      }
    } catch (error) {
      setIsErrorVisible(true);
      if (error.response && error.response.status === 401) {
        setIsInfoVisible(true);
      }
    } finally {
      setIsSuccessVisible(true);
      setLoading(false);
    }
  }, [])

  const handleRefresh = () => {
    fetchAllData(currentPage);
  };

  const handleSearch = useCallback(
    async (page = 1) => {
      try {
        const params = new URLSearchParams();
        if (searchTerm) params.append("search", searchTerm);

        const response = await apiClient.get(
          `/product_price?${params.toString()}&page=${page}`
        );

        if (Array.isArray(response.data.results)) {
          setData(response.data.results);
        } else {
          setData([response.data.results]);
        }
        setTotalItems(response.data.total);
      } catch (error) {
        if (error.response && error.response.status === 401) {
          setIsInfoVisible(true);
        }
      }
    },
    [searchTerm]
  );
  const handleFresh = async () => {
    //handleSearch(1);
    setCurrentPage(1);
    setSearchTerm(searchInput.trim());
  };

  useEffect(() => {
        if (searchTerm) {
          handleSearch(currentPage);
        } else {
          fetchAllData(currentPage);
        }
        
      }, [fetchAllData, handleSearch, searchTerm, currentPage]);

  const handleDeleteModal = (item) => {
    setSelectedDeleteItem(item);
    setDeleteItem(true);
  };
  const handleCloseDeleteModal = () => {
    setDeleteItem(false);
    setSelectedDeleteItem(null);
    handleRefresh();
  };

  const handleClick = () => {
    navigate(`/Management`);
  };

  const openSyncModal = () => {
    setIsSyncOpen(true);
  };
  const closeSyncModal = () => {
    setIsSyncOpen(false);
  };

  const columns = [
    { title: "Id", key: "id" },
    { title: "Módulo", key: "moduleTemplateDescription" },
    { title: "Precio de Compra", key: "purchasePrice" },
    { title: "Precio Unitario", key: "perUserPrice" },
    { title: "Descuento", key: "discount" },
    { title: "Estado", key: "flagActive" },
    { title: "Acciones", key: "acciones" },
  ];

  const renderRow = (item, index) => (
    <>
      <td>{item.id}</td>
      <td>{item.moduleTemplateDescription}</td>
      <td>{item.purchasePrice}</td>
      <td>{item.perUserPrice}</td>
      <td>{item.discount}</td>
      <td>
        {item.flagActive ? (
          <button className="status_button">
            <FontAwesomeIcon
              icon={faCircleCheck}
              style={{ color: "green", fontSize: "24px" }}
            />
          </button>
        ) : (
          <button className="status_button">
            <FontAwesomeIcon
              className="status_icon"
              icon={faCircleXmark}
              style={{ color: "red", fontSize: "24px" }}
            />
          </button>
        )}
      </td>
      <td>
        <div className="button-container">
          <div className="desktop-buttons">
            <Tooltip id="contract-tooltip" className="custom-tooltip" />
            {hasPermission("PRODUCT_PRICE_VIEW") && (
              <button
                className="icon-button company-button"
                onClick={() => toggleModal(item)}
                data-tooltip-id="contract-tooltip"
                data-tooltip-content="Detalle"
              >
                <FontAwesomeIcon icon={faEye} />
              </button>
            )}
            <Tooltip id="edit-tooltip" className="custom-tooltip" />
            {hasPermission("PRODUCT_PRICE_UPDATE") && (
              <button
                data-tooltip-id="edit-tooltip"
                className="icon-button edit-button"
                data-tooltip-content="Editar"
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(`/ProductPriceForm/${item.id}`);
                }}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
            )}
            <Tooltip id="delete-tooltip" className="custom-tooltip" />
            {hasPermission("PRODUCT_PRICE_DELETE") && (
              <button
                data-tooltip-id="delete-tooltip"
                data-tooltip-content="Eliminar"
                className="icon-button delete-button"
                onClick={() => handleDeleteModal(item)}
                //onClick={() => handleDelete(item.id)}
              >
                <FontAwesomeIcon icon={faTrashAlt} />
              </button>
            )}
          </div>

          <div className="mobile-dropdown">
            <div className="dropdown-container-contract">
              <button
                className="icon-button dropdown-button-contract"
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenDropdown(openDropdown === item.id ? null : item.id);
                }}
              >
                <FontAwesomeIcon icon={faEllipsisH} />
              </button>
              {openDropdown === item.id && (
                <div className="dropdown-menu-contract dm-class">
                  {hasPermission("PRODUCT_PRICE_VIEW") && (
                    <button
                      className="dropdown-item-contract"
                      onClick={() => toggleModal(item)}
                    >
                      Detalle
                    </button>
                  )}
                  {hasPermission("PRODUCT_PRICE_UPDATE") && (
                    <button
                      className="dropdown-item-contract"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/ProductPriceForm/${item.id}`);
                      }}
                    >
                      Editar
                    </button>
                  )}
                  {hasPermission("PRODUCT_PRICE_DELETE") && (
                    <button
                      className="dropdown-item-contract"
                      onClick={() => {
                        handleDeleteModal(item);
                        setOpenDropdown(false);}}
                    >
                      Eliminar
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </td>
    </>
  );

  return (
    <div className="home-container">
      <Header onLogout={handleLogout} title="Precios de Productos" />
      <div className="home-content">
        <Section>
          <div className="button-return-container">
            <div className="contener-return">
              <FontAwesomeIcon
                className="basic-shortcut-icon"
                style={{ cursor: "pointer" }}
                icon={faCircleArrowLeft}
                onClick={handleClick}
              />
            </div>
            <div className="filter-form">
              <div className="basic-info-form-group">
                <input
                  type="text"
                  id="product-price"
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                  placeholder="Precio de Producto"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleFresh();
                    }
                  }}
                />
              </div>
              <button className="basic-custom-button" onClick={handleFresh}>
                <FontAwesomeIcon
                  icon={faSearch}
                  className="basic-shortcut-icon"
                />
                Buscar
              </button>
            </div>
          </div>

          <div className="button-add">
            {hasPermission('PRODUCT_PRICE_UPDATE') && (
              <button
                className="basic-custom-button"
                onClick={() => openSyncModal()}
              >
                <FontAwesomeIcon className="basic-shortcut-icon" icon={faRotate} />
                Sync Precios de Productos
              </button>
            )}
            {hasPermission("PRODUCT_PRICE_CREATE") && (
              <button
                className="basic-custom-button"
                onClick={(e) => {
                  e.stopPropagation();
                  navigate("/ProductPriceForm");
                }}
              >
                <FontAwesomeIcon
                  className="basic-shortcut-icon"
                  icon={faMoneyCheckDollar}
                />
                Crear Nuevo Precio de Producto
              </button>
            )}
          </div>
        </Section>
        <Table
          title="Lista de Precios de Productos"
          rows={data}
          columns={columns}
          icon={faMoneyCheckDollar}
          renderRow={renderRow}
          currentPage={currentPage}
          totalItems={totalItems}
          itemsPerPage={itemsPerPage}
          onPageChange={setCurrentPage}
          onRefresh={handleRefresh}
          loading={loading}
          flagPagination={true}
        />
        <SuccessNotification
          message={"Se ha cargado correctamente"}
          isVisible={isSuccessVisible}
          onClose={() => setIsSuccessVisible(false)}
        />
        <ErrorNotification
          message="Ups! Ocurrio un Problema"
          isVisible={isErrorVisible}
          onClose={() => setIsErrorVisible(false)}
        />
        <LoginNotification
          message="Vuele a iniciar sesión"
          isVisible={isInfoVisible}
          onClose={() => setIsInfoVisible(false)}
          onLogout={handleLogout}
        />
        {selectedDeleteItem && (
          <DeleteModal
            isVisible={deleteItem}
            onClose={handleCloseDeleteModal}
            identificator={selectedDeleteItem.id}
            url={`/product_price`}
          />
        )}
        {isSyncOpen && (
          <SyncProdPriceModal
            isVisible={isSyncOpen}
            onClose={() => closeSyncModal()}
            onSuccess={fetchAllData}
          />
        )}
        <SlideModal
          isOpen={isModalOpen}
          onClose={toggleModal}
          title="Detalles del Precio de Producto"
        >
          <div className="section-container-form">
            <h4 className="section-title-form">ID</h4>
            <hr className="section-divider-form" />
            <div className="form-group-form">
              <label>{selectedItemToggle?.general.id}</label>
            </div>

            <h4 className="section-title-form">ID MÓDULO</h4>
            <hr className="section-divider-form" />
            <div className="form-group-form">
              <label>{selectedItemToggle?.alternative.templateId}</label>
            </div>
            <h4 className="section-title-form">MÓDULO</h4>
            <hr className="section-divider-form" />
            <div className="form-group-form">
              <label>
                {selectedItemToggle?.alternative.moduleTemplateDescription}
              </label>
            </div>

            <h4 className="section-title-form">PRECIO DE COMPRA</h4>
            <hr className="section-divider-form" />
            <div className="form-group-form">
              <label>{selectedItemToggle?.general.purchasePrice}</label>
            </div>

            <h4 className="section-title-form">PRECIO POR USUARIO</h4>
            <hr className="section-divider-form" />
            <div className="form-group-form">
              <label>{selectedItemToggle?.general.perUserPrice}</label>
            </div>

            <h4 className="section-title-form">DESCUENTO</h4>
            <hr className="section-divider-form" />
            <div className="form-group-form">
              <label>{selectedItemToggle?.general.discount}</label>
            </div>

            <h4 className="section-title-form">FECHA DE VIGENCIA</h4>
            <hr className="section-divider-form" />
            <div className="form-group-form">
              <label>{selectedItemToggle?.general.effectiveDate}</label>
            </div>

            <h4 className="section-title-form">FECHA DE EXPIRACIÓN</h4>
            <hr className="section-divider-form" />
            <div className="form-group-form">
              <label>{selectedItemToggle?.general.expirationDate}</label>
            </div>

            <h4 className="section-title-form">ESTADO</h4>
            <hr className="section-divider-form" />
            <div className="form-group-form">
              <label>
                {selectedItemToggle?.general.flagActive === 1
                  ? "Activo"
                  : "Inactivo"}
              </label>
            </div>

            <h4 className="section-title-form">DESCRIPCIÓN DE MÓDULO</h4>
            <hr className="section-divider-form" />
            <div className="form-group-form">
              <label>{selectedItemToggle?.alternative.moduleDescription}</label>
            </div>

            <h4 className="section-title-form">CÓDIGO DE MÓDULO</h4>
            <hr className="section-divider-form" />
            <div className="form-group-form">
              <label>{selectedItemToggle?.alternative.moduleCode}</label>
            </div>

            <h4 className="section-title-form">TIPO DE CONTRATO</h4>
            <hr className="section-divider-form" />
            <div className="form-group-form">
              <label>{selectedItemToggle?.alternative.contractType}</label>
            </div>

            <h4 className="section-title-form"> </h4>
          </div>
        </SlideModal>
      </div>
    </div>
  );
};

export default ProductPriceList;
